import React, { useState, useEffect } from "react";
import { Button, Icon, Checkbox, Container, Header } from "semantic-ui-react";
import { AVAIL_SCOPES } from "env.config";
import { isAppExist } from "utils/map-utils";
import { AddAppDetail } from "./AddAppDetail";
import { EditAppDetail } from "./EditAppDetail";
import { DeleteAppDetail } from "./DeleteAppDetail";
import { PendingRowWithoutTable } from "components/Admin/PendingRow";
import { getClientSecret, getEnvide, getApiKeyValue } from "services/developer";

const AppActionContainer = ({
  appDetail,
  setOpenDeleteModal,
  setOpenEditModal,
  setOpenAddAppModal,
}) => {
  const AddContainer = () => (
    <div className="action-group">
      <Button icon onClick={() => setOpenAddAppModal(true)}>
        <Icon name="plus" />
      </Button>
    </div>
  );
  const EditContainer = () => (
    <>
      <div className="action-group">
        <Button icon onClick={() => setOpenDeleteModal(true)}>
          <Icon name="trash" />
        </Button>
        <Button
          icon
          onClick={() => {
            setOpenEditModal(true);
          }}
        >
          <Icon name="pencil" />
        </Button>
      </div>
    </>
  );
  if (appDetail) {
    if (appDetail.AppId) {
      return <EditContainer />;
    } else {
      return <AddContainer />;
    }
  }
  return null;
};

const DisplayAppDetail = ({ appDetail, appLoaded, identityId }) => {
  const PendingApp = () => {
    const DEFAULT_LENGTH = 4;
    return (
      <div>
        {Array.from({ length: DEFAULT_LENGTH }).map((_value, index) => {
          return <PendingRowWithoutTable key={index} />;
        })}
      </div>
    );
  };
  if (!appLoaded) {
    return <PendingApp />;
  }
  return (
    <div>
      <div className="row-container">
        <div className="col-1">App Name</div>
        <div>{appDetail && appDetail.AppName}</div>
      </div>
      <ToggleClientInfo appDetail={appDetail} identityId={identityId} />
      <div className="row-container">
        <div className="col-1">Allowed Scopes</div>
        <div>
          <div>
            {AVAIL_SCOPES.map((item) => {
              return (
                <Checkbox
                  style={{ marginRight: "10px" }}
                  key={item}
                  label={item}
                  value={item}
                  readOnly
                  checked={
                    appDetail &&
                    appDetail.OauthScope &&
                    appDetail.OauthScope.includes(item)
                  }
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const ToggleClientInfo = ({ appDetail, identityId }) => {
  const [showClientId, setShowClientId] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [showAPIKey, setShowAPIKey] = useState(false);
  const [APIKeyValue, setAPIKeyValue] = useState("");
  const handleShowClientSecret = async () => {
    if (!clientSecret) {
      const res = await getClientSecret({
        UserName: appDetail.UserName,
      });
      setClientSecret(res.Item);
    }
    setShowClientSecret(true);
  };

  const getAPIKey = async () => {
    if (!APIKeyValue) {
      if (identityId) {
        const value = await getApiKeyValue(identityId);
        setAPIKeyValue(value);
      }
    }
    setShowAPIKey(true);
  };

  return (
    <>
      <div className="row-container">
        <div className="col-1">API Key</div>
        <div>
          {isAppExist(appDetail) &&
            (showAPIKey ? (
              <>
                <span style={{ marginRight: "10px" }}>{APIKeyValue}</span>
                <span
                  className="toggle-icon"
                  onClick={() => setShowAPIKey(false)}
                >
                  <Icon name="eye slash" />
                </span>
              </>
            ) : (
              <>
                <span style={{ marginRight: "10px" }}>
                  ********************************
                </span>
                <span className="toggle-icon" onClick={() => getAPIKey()}>
                  <Icon name="eye" />
                </span>
              </>
            ))}
        </div>
      </div>
      <div className="row-container">
        <div className="col-1">Client ID</div>
        <div>
          {isAppExist(appDetail) &&
            (showClientId ? (
              <>
                <span style={{ marginRight: "10px" }}>{appDetail.AppId}</span>
                <span
                  className="toggle-icon"
                  onClick={() => setShowClientId(false)}
                >
                  <Icon name="eye slash" />
                </span>
              </>
            ) : (
              <>
                <span style={{ marginRight: "10px" }}>
                  ********************************
                </span>
                <span
                  className="toggle-icon"
                  onClick={() => setShowClientId(true)}
                >
                  <Icon name="eye" />
                </span>
              </>
            ))}
        </div>
      </div>
      <div className="row-container">
        <div className="col-1">Client Secret</div>
        <div>
          {isAppExist(appDetail) &&
            (showClientSecret ? (
              <>
                <span style={{ marginRight: "10px" }}>{clientSecret}</span>
                <span
                  className="toggle-icon"
                  onClick={() => setShowClientSecret(false)}
                >
                  <Icon name="eye slash" />
                </span>
              </>
            ) : (
              <>
                <span style={{ marginRight: "10px" }}>
                  ********************************
                </span>
                <span
                  className="toggle-icon"
                  onClick={() => handleShowClientSecret()}
                >
                  <Icon name="eye" />
                </span>
              </>
            ))}
        </div>
      </div>
    </>
  );
};

const AppDetail = ({
  appDetail,
  onSaveUpdateApp,
  appLoaded,
  email,
  identityId,
  ENVIDE
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAddModal, setOpenAddAppModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [appFormData, setAppFormData] = useState({
    appName: "",
    oauthScope: [],
    appNameValid: true,
    appNameErrorMessage: "",
    oauthScopeValid: true,
  });
 
  const onClickEditModal = () => {
    setAppFormData({
      ...appFormData,
      appName: appDetail.AppName,
      oauthScope: appDetail.OauthScope,
    });
    setOpenEditModal(true);
  };

  return (
    <Container className="app-detail-container">
      <Header as="h3">App Details</Header>
      <AppActionContainer
        appDetail={appDetail}
        setOpenDeleteModal={setOpenDeleteModal}
        setOpenEditModal={onClickEditModal}
        setOpenAddAppModal={setOpenAddAppModal}
      />
      <DisplayAppDetail
        appLoaded={appLoaded}
        appDetail={appDetail}
        identityId={identityId}
      />
      <EditAppDetail
        setOpenEditModal={setOpenEditModal}
        openEditModal={openEditModal}
        appFormData={appFormData}
        setAppFormData={setAppFormData}
        appDetail={appDetail}
        onSaveUpdateApp={onSaveUpdateApp}
        ENVIDE={ENVIDE}
      />
      <AddAppDetail
        email={email}
        appFormData={appFormData}
        setAppFormData={setAppFormData}
        openAddModal={openAddModal}
        setOpenAddAppModal={setOpenAddAppModal}
        onSaveUpdateApp={onSaveUpdateApp}
        ENVIDE={ENVIDE}
      />
      <DeleteAppDetail
        appDetail={appDetail}
        openDeleteModal={openDeleteModal}
        setAppFormData={setAppFormData}
        setOpenDeleteModal={setOpenDeleteModal}
        onSaveUpdateApp={onSaveUpdateApp}
      />
    </Container>
  );
};

export { ToggleClientInfo, AppDetail };
